import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatOptionSelectionChange } from '@angular/material/core';
import { DataType, DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO, SelectRuleDO, SelectSmartFilterDO } from '../../../../../../system/system-dtos';
import { BlastV2Service } from '../../../../../views/main-table-v2/service/blast-v2.service';

@Component({
  selector: 'app-form-field-rule',
  templateUrl: './smart-filter-form-field.component.html',
  styleUrls: ['./smart-filter-form-field.component.scss'],
  standalone: false,
})
export class SmartFilterFormField extends DataTypeComponent implements OnInit, OnDestroy {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @Input() editMode: boolean;

  rowData: any;

  filters: SelectSmartFilterDO[] = [];

  smartFilterData: any;

  selected: SelectSmartFilterDO;

  fields: FieldConfigDTO[];

  selectedFieldConfig: FieldConfigDTO;

  filterId: any;

  constructor(private blastService: BlastV2Service) {
    super();
  }

  ngOnInit() {
    this.blastService.getCollectionObservable('smartfilters').subscribe((list) => {
      this.filters = list.sort((a: SelectSmartFilterDO, b: SelectSmartFilterDO) => a.displayOrder - b.displayOrder);

      if (this.data !== undefined && this.rowData !== undefined) {
        this.onSmartFilterChange(
          this.data.smartFilter || this.data,
          new MatOptionSelectionChange(null, true),
          this.rowData.smartFilterData
        );
      }
    });
  }

  onSmartFilterChange(smartFilter: SelectSmartFilterDO, $event: MatOptionSelectionChange, smartFilterData) {
    if (!$event.isUserInput || (this.selected && smartFilter.id === this.selected.id)) {
      return;
    }
    this.selected = smartFilter;
    this.formGroup.get(this.fieldConfig.name).setValue(this.selected);
    this.filterId = smartFilter ? smartFilter.id : null;

    this.fields = [];
    if (this.selected && this.selected.formConfig) {
      this.selected.formConfig.forEach((row) => {
        row.columns.forEach((column) => {
          column.fields.forEach((f) => {
            this.fields.push(f);
          });
        });
      });
    }

    if (smartFilterData && !(Object.keys(smartFilterData).length === 0 && smartFilterData.constructor === Object)) {
      this.smartFilterData = smartFilterData;
    } else {
      this.smartFilterData = smartFilter.dataTemplate;
    }
    this.selectedFieldConfig = {
      name: 'smartFilterData',
      label: 'Criteria',
      type: DataType.criteria,
    } as FieldConfigDTO;
    this.selectedFieldConfig.innerFields = this.fields;
  }

  setRowData(entity: any) {
    this.rowData = entity;
    if (this.data !== undefined && this.rowData !== undefined) {
      this.onSmartFilterChange(
        this.data.smartFilter || this.data,
        new MatOptionSelectionChange(null, true),
        this.rowData.smartFilter.smartFilterData || this.rowData.smartFilterData
      );
    }
  }

  ngOnDestroy() {}
}
